import { Directive, EventEmitter, Host, HostBinding, Input, Output } from '@angular/core';

/**
 * @Remarks This is the base class for a tab panel tab. Extend this to get the basic functionality of a tab.
 */
@Directive()
export abstract class TabBase {
  @Input() title: string;
  @Input() titleBadge: string;
  @Input() titleIcon: string;
  @HostBinding('class.active')
  @Input() active = false;
  @HostBinding('class.disabled')
  @Input() disabled = false;
  @Input() ngClassOverride: Record<string, any> = {};
  @Input() ngStyleOverride: Record<string, any> = {};
  @Input() error = false;

  @Output() selectTab = new EventEmitter<string>();
  @Output() selectNext = new EventEmitter<void>();
  @Output() selectPrevious = new EventEmitter<void>();

  @HostBinding('class.tab-pane') private tabPane = true;
  @HostBinding('id') private _id: string;

  get id(): string {
    return this._id;
  }

  constructor() { 
    this._id = _.uniqueId("TabPanel_");
  }

  selected(): void {
    // NOOP
  }

  deselected(): void {
    // NOOP
  }
}